<template>
  <div class="ma-2" id="listener_layout" @mouseup="handleMouseUp">
    <!-- Div per la tooltip del drag -->
    <div
      :style="{
        backgroundColor: 'white',
        border: '1px solid black',
        display: 'inline-block',
        left: cursor_x + 'px',
        opacity: 0.7,
        pointerEvents: 'none',
        position: 'absolute',
        top: cursor_y + 'px',
        zIndex: 100,
      }"
      v-if="drag_state === 'on'"
    >
      <v-icon
        :color="oggetto_sel.colore_icona"
        v-if="oggetto_sel.tipo_oggetto === 'B'"
      >
        {{ oggetto_sel.icona }}
      </v-icon>
      <div v-else-if="oggetto_sel.tipo_oggetto === 'D'">
        <span
          :style="{
            color: oggetto_sel.font_color_titolo,
            fontSize: 12,
            fontWeight: oggetto_sel.font_weight_titolo,
          }"
        >
          {{ oggetto_sel.tooltip }} </span
        ><br />
        <span
          :style="{
            color: oggetto_sel.font_color_dato,
            fontSize: 12,
            fontWeight: oggetto_sel.font_weight_dato,
          }"
          >[Dato]
        </span>
      </div>
      <div v-else-if="oggetto_sel.tipo_oggetto === 'I'">
        <span
          :style="{
            fontSize: 12,
          }"
        >
          [{{ oggetto_sel.testo }}]
        </span>
      </div>
      <div v-else-if="oggetto_sel.tipo_oggetto === 'N'">
        <span
          :style="{
            fontSize: 12,
          }"
        >
          [{{ oggetto_sel.text }}]
        </span>
      </div>
    </div>
    <v-row>
      <!-- Spazio degli elementi draggabili -->
      <v-col cols="2">
        <v-card height="90vh" style="overflow-y: scroll; overflow-x: clip">
          <v-toolbar color="indigo" dense style="border-radius: 0px">
            <v-toolbar-title class="white--text"> Bottoni </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_tabella_bottoni = true"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="primary">mdi-cog-outline</v-icon></v-btn
                >
              </template>
              <span>Impostazioni</span>
            </v-tooltip>
          </v-toolbar>
          <v-tooltip bottom :key="i" v-for="(bottone, i) in items_btn">
            <!-- Lista dei bottoni -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-2"
                :color="bottone.colore_sfondo"
                @contextmenu="editButton($event, bottone)"
                @mousedown="startDragItem($event, bottone)"
                @mouseup="handleMouseUp"
                small
                tile
                v-bind="attrs"
                v-on="on"
              >
                <v-icon :color="bottone.colore_icona">{{
                  bottone.icona
                }}</v-icon>
              </v-btn>
            </template>
            <span>{{ bottone.tooltip }}</span>
          </v-tooltip>

          <v-toolbar color="indigo" dense style="border-radius: 0px">
            <v-toolbar-title class="white--text">
              Informazioni
            </v-toolbar-title>
          </v-toolbar>
          <!-- Lista delle informazioni -->
          <div
            class="ma-2"
            @contextmenu="editDatum($event, info)"
            :key="info.id_layout_dettaglio_tmp"
            @mousedown="startDragItem($event, info)"
            style="
              border: 1px solid black;
              border-radius: 0px;
              display: inline-block;
              font-size: 13px;
              max-width: 100px;
              padding: 5px;
              user-select: none;
            "
            v-for="info in items_info"
          >
            {{ info.tooltip }}
          </div>

          <!-- Lista degli elementi -->
          <v-toolbar color="indigo" dense style="border-radius: 0px">
            <v-toolbar-title class="white--text"> Elementi </v-toolbar-title>
          </v-toolbar>
          <div
            class="ma-2"
            :key="elemento.id_layout_dettaglio_tmp"
            @mousedown="startDragItem($event, elemento)"
            style="
              border: 1px solid black;
              border-radius: 0px;
              display: inline-block;
              font-size: 13px;
              max-width: 100px;
              padding: 5px;
              user-select: none;
            "
            v-for="elemento in items_elementi"
          >
            {{ elemento.text }}
          </div>
        </v-card>
      </v-col>

      <!-- Spazio della dashboard -->
      <v-col cols="6" :key="key_rows">
        <v-toolbar color="indigo" dense v-if="titolo_layout_sel !== null">
          <v-row align="center" justify="center">
            <v-col cols="6" align="left">
              <v-toolbar-title class="white--text">
                {{ titolo_layout_sel }}
              </v-toolbar-title>
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                hide-details
                solo
                v-model="modulo_layout_sel"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-container fluid>
          <!-- Ingresso della dashboard vera e propria -->
          <LayoutRow
            :drag_state="drag_state"
            :key="i"
            :riga="riga"
            v-for="(riga, i) in colonne[0].righe.filter((r) => r.validita == 1)"
          />
        </v-container>
      </v-col>

      <!-- Spazio delle configurazioni -->
      <v-col cols="4">
        <v-card height="90vh" style="overflow-y: scroll; overflow-x: clip">
          <v-toolbar color="indigo" dense style="border-radius: 0px">
            <v-toolbar-title class="white--text"> Opzioni </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="goBack" small v-bind="attrs" v-on="on">
                  <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                </v-btn>
              </template>
              <span>Indietro</span>
            </v-tooltip>
          </v-toolbar>

          <!-- Spazio delle modifiche generali -->
          <v-container fluid>
            <v-row align="center" justify="center">
              <!-- Bottone del nuovo layout -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2 my-1"
                    @click="goToRoot"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-home</v-icon>
                  </v-btn>
                </template>
                <span>Torna alla Root</span>
              </v-tooltip>

              <!-- Bottone del nuovo layout -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickNewLayout"
                    class="mx-2 my-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-file-plus</v-icon>
                  </v-btn>
                </template>
                <span>Nuovo Layout</span>
              </v-tooltip>

              <!-- Bottone di copia negli appunti -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="copyLayoutToClipboard"
                    class="mx-2 my-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-file-export</v-icon>
                  </v-btn>
                </template>
                <span>Copia negli Appunti</span>
              </v-tooltip>

              <!-- Bottone di importazione -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickImportaLayout"
                    class="mx-2 my-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-file-import</v-icon>
                  </v-btn>
                </template>
                <span>Importa</span>
              </v-tooltip>
            </v-row>
            <v-row align="center" justify="center">
              <!-- Bottone di salvataggio -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2 my-1"
                    @click="salvaLayout"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>

              <!-- Bottone di caricamento -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickCaricaDialog"
                    class="mx-2 my-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-folder</v-icon>
                  </v-btn>
                </template>
                <span>Carica</span>
              </v-tooltip>

              <!-- Bottone di gestione delle associazioni -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickAssociazioneProfili"
                    class="mx-2 my-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-account-multiple</v-icon>
                  </v-btn>
                </template>
                <span>Associazione Profili</span>
              </v-tooltip>

              <!-- Bottone di gestione della query principale -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="openDialogQueryPrincipale"
                    class="mx-2 my-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-database</v-icon>
                  </v-btn>
                </template>
                <span>Query Principale</span>
              </v-tooltip>
            </v-row>
          </v-container>

          <!-- Spazio della modifica della colonna selezionata -->
          <span v-if="modalita_selezione === 'colonna'">
            <v-toolbar color="indigo" dense style="border-radius: 0px">
              <v-toolbar-title class="white--text">
                {{
                  colonna_sel.id_padre_tmp === null
                    ? ""
                    : `Colonna ${colonna_sel.ordine}`
                }}
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <!-- Bottone impostazioni colonna attualmente selezionata -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    @click="editColumn(colonna_sel)"
                    :disabled="colonna_sel.id_padre_tmp === null"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <span>Impostazioni Colonna</span>
              </v-tooltip>

              <!-- Bottone nuova riga -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    @click="addRow"
                    :disabled="
                      colonna_sel.oggetto.filter((o) => o.validita != 0)
                        .length > 0
                    "
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-table-row-plus-after</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi Riga</span>
              </v-tooltip>

              <!-- Bottone di risalita di livello -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    @click="goUp(colonna_sel)"
                    :disabled="colonna_sel.id_padre_tmp === null"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-arrow-up-left</v-icon>
                  </v-btn>
                </template>
                <span>Livello Superiore</span>
              </v-tooltip>
            </v-toolbar>

            <!-- Elenco di righe nella colonna -->
            <v-container fluid>
              <draggable
                @change="assegnaOrdine(colonna_sel.righe)"
                v-model="colonna_sel.righe"
              >
                <v-row
                  class="pt-2 px-2"
                  :key="j"
                  v-for="(riga, j) in colonna_sel.righe.filter(
                    (r) => r.validita == 1
                  )"
                >
                  <b>{{ `Riga ${riga.ordine}` }}</b>

                  <!-- Bottone di selezione (espansione) della riga -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="selectRow(riga)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary">mdi-magnify-expand</v-icon>
                      </v-btn>
                    </template>
                    <span>Seleziona Riga</span>
                  </v-tooltip>

                  <!-- Bottone di modifica della riga -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="editRow(riga)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary">mdi-cogs</v-icon>
                      </v-btn>
                    </template>
                    <span>Impostazioni Riga</span>
                  </v-tooltip>

                  <!-- Bottone di clonazione della riga -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="cloneRow(riga)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary">mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Clona Riga</span>
                  </v-tooltip>

                  <!-- Bottone di cancellazione della riga -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="deleteRow(colonne, riga)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Cancella Riga</span>
                  </v-tooltip>
                </v-row>
              </draggable>

              <!-- Elenco degli oggetti nella colonna -->
              <v-row
                class="pt-2 px-2"
                v-for="(oggetto, k) in colonna_sel.oggetto.filter(
                  (o) => o.validita == 1
                )"
                :key="k"
              >
                <b>{{ `Oggetto "${oggetto.tipologia}"` }}</b>

                <!-- Bottone di modifica della riga -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      @click="
                        oggetto.tipo_oggetto === 'N'
                          ? editNotification(oggetto)
                          : editObject(oggetto)
                      "
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-cogs</v-icon>
                    </v-btn>
                  </template>
                  <span>Impostazioni Oggetto</span>
                </v-tooltip>

                <!-- Bottone di cancellazione dell'oggetto -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      @click="
                        oggetto.tipo_oggetto == 'I'
                          ? deleteObject(
                              colonne,
                              'id_layout_dettaglio_tmp',
                              oggetto.id_layout_dettaglio_tmp
                            )
                          : deleteObject(
                              colonne,
                              'id_header',
                              oggetto.id_header
                            )
                      "
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancella Oggetto</span>
                </v-tooltip>
              </v-row>
            </v-container>
          </span>

          <!-- Spazio di modifica della riga selezionata -->
          <span v-else-if="modalita_selezione === 'riga'">
            <v-toolbar color="indigo" dense style="border-radius: 0px">
              <v-toolbar-title class="white--text">
                Riga {{ riga_sel.ordine }}
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <!-- Bottone di modifica della riga selezionata -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    @click="editRow(riga_sel)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <span>Impostazioni Riga</span>
              </v-tooltip>

              <!-- Bottone di aggiunta di una colonna -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    @click="addCol()"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi Colonna</span>
              </v-tooltip>

              <!-- Bottone di risalita di livello -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    @click="goUp(riga_sel)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-arrow-up-left</v-icon>
                  </v-btn>
                </template>
                <span>Livello Superiore</span>
              </v-tooltip>
            </v-toolbar>

            <!-- Elenco di colonne nella riga -->
            <v-container fluid>
              <draggable
                @change="assegnaOrdine(riga_sel.colonne)"
                v-model="riga_sel.colonne"
              >
                <v-row
                  class="pt-2 px-2"
                  v-for="(colonna, j) in riga_sel.colonne.filter(
                    (c) => c.validita == 1
                  )"
                  :key="j"
                >
                  <b>{{ `Colonna ${colonna.ordine}` }}</b>

                  <!-- Bottone di selezione (espansione) della colonna -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="selectColumn(colonna)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary">mdi-magnify-expand</v-icon>
                      </v-btn>
                    </template>
                    <span>Seleziona Colonna</span>
                  </v-tooltip>

                  <!-- Bottone di modifica della colonna -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="editColumn(colonna)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary">mdi-cogs</v-icon>
                      </v-btn>
                    </template>
                    <span>Impostazioni Colonna</span>
                  </v-tooltip>

                  <!-- Bottone di clonazione della colonna -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="cloneColumn(colonna)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary">mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Clona Colonna</span>
                  </v-tooltip>

                  <!-- Bottone di cancellazione della colonna -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        @click="deleteColumn(colonne, colonna)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Cancella Colonna</span>
                  </v-tooltip>
                </v-row>
              </draggable>
            </v-container>
          </span>

          <!-- Spazio di elencazione delle opzioni -->
          <span>
            <v-toolbar
              class="mt-5"
              color="indigo"
              dense
              style="border-radius: 0px"
            >
              <v-toolbar-title class="white--text">
                Operazioni
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="visualizzaOperazioni"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Visualizza Operazioni</span>
              </v-tooltip>
            </v-toolbar>

            <v-container>
              <v-row
                class="pt-2 px-2"
                v-for="(operazione, k) in items_operazioni_used"
                :key="k"
              >
                {{ operazione.cod_operazione }} ●
                {{ operazione.des_operazione }}
              </v-row>
            </v-container>
          </span>

          <!-- Toolbar delle notifiche -->
          <span>
            <v-toolbar
              class="mt-5"
              color="indigo"
              dense
              style="border-radius: 0px"
            >
              <v-toolbar-title class="white--text"> Notifiche </v-toolbar-title>

              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungiNotifica"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Visualizza Operazioni</span>
              </v-tooltip>
            </v-toolbar>

            <div
              class="ma-2"
              :key="l"
              @mousedown="startDragItem($event, notifica)"
              @contextmenu="editNotification($event, notifica)"
              style="
                border: 1px solid black;
                border-radius: 0px;
                display: inline-block;
                font-size: 13px;
                max-width: 100px;
                padding: 5px;
                user-select: none;
              "
              v-for="(notifica, l) in items_notifiche"
            >
              {{ notifica.text }}
            </div>
          </span>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog di modifica della riga -->
    <v-dialog v-model="dialog_modifica_riga" width="700">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Riga
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaRiga(colonne)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_riga = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni della riga -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Col."
                  max="12"
                  min="1"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="riga_tmp.dimensione"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Input delle dimensioni del font dell'icona -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Icona"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="riga_tmp.font_size_icona"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni del font del titolo -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Titolo"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="riga_tmp.font_size_titolo"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni del font del dato -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Dato"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="riga_tmp.font_size_dato"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col align="center" cols="3">
                <!-- Campo di input dello stile del font del titolo -->
                <v-select
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Font Titolo"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="riga_tmp.font_weight_titolo"
                ></v-select>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input dello stile del font del dato -->
                <v-select
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Font Dato"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="riga_tmp.font_weight_dato"
                ></v-select>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  :false-value="0"
                  label="Riga Intestazione"
                  :true-value="1"
                  v-model="riga_tmp.intestazione"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col align="center" cols="3">
                <!-- Campo di input del colore del font del titolo -->
                <div>
                  <div>Colore Font Titolo</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: riga_tmp.font_color_titolo,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="riga_tmp.font_color_titolo"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input del colore del font del dato -->
                <div>
                  <div>Colore Font Dato</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: riga_tmp.font_color_dato,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="riga_tmp.font_color_dato"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input del colore dello sfondo della riga -->
                <div>
                  <div>Sfondo Riga</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: riga_tmp.colore_riga,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="riga_tmp.colore_riga"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <v-col align="center" cols="3">
                <!-- Campo di input del colore dello sfondo della colonna -->
                <div>
                  <div>Sfondo Colonna</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: riga_tmp.colore_colonna,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="riga_tmp.colore_colonna"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica della colonna -->
    <v-dialog v-model="dialog_modifica_colonna" width="80vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Colonna
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaColonna(colonne)"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon></v-btn
              >
            </template>
            <span>Applica</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_colonna = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <!-- Corpo del dialog -->
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni della riga -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Col."
                  max="12"
                  min="1"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="colonna_tmp.dimensione"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Input delle dimensioni del font dell'icona -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Icona"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="colonna_tmp.font_size_icona"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni del font del titolo -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Titolo"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="colonna_tmp.font_size_titolo"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni del font del dato -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Dato"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="colonna_tmp.font_size_dato"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col align="center" cols="3">
                <!-- Campo di input dello stile del font del titolo -->
                <v-select
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Font Titolo"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="colonna_tmp.font_weight_titolo"
                ></v-select>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input dello stile del font del dato -->
                <v-select
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Font Dato"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="colonna_tmp.font_weight_dato"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col align="center" cols="4">
                <!-- Campo di input del colore del font del titolo -->
                <div>
                  <div>Colore Font Titolo</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: colonna_tmp.font_color_titolo,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="colonna_tmp.font_color_titolo"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <v-col align="center" cols="4">
                <!-- Campo di input del colore del font del dato -->
                <div>
                  <div>Colore Font Dato</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: colonna_tmp.font_color_dato,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="colonna_tmp.font_color_dato"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <v-col align="center" cols="4">
                <!-- Campo di input del colore dello sfondo della colonna -->
                <div>
                  <div>Sfondo Colonna</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: colonna_tmp.colore_colonna,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="colonna_tmp.colore_colonna"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica dell'oggetto -->
    <v-dialog v-model="dialog_modifica_oggetto" max-width="700px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Oggetto
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaOggetto(colonne)"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon></v-btn
              >
            </template>
            <span>Applica</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_oggetto = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <!-- Corpo del dialog -->
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="start">
              <v-col align="center" cols="3">
                <!-- Input delle dimensioni del font dell'icona -->
                <v-text-field
                  dense
                  hide-details
                  label="Dim. Font Icona"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="oggetto_sel.font_size_icona"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni del font del titolo -->
                <v-text-field
                  dense
                  hide-details
                  :disabled="oggetto_sel.tipo_oggetto != 'D'"
                  label="Dim. Font Titolo"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="oggetto_sel.font_size_titolo"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input delle dimensioni del font del dato -->
                <v-text-field
                  dense
                  :disabled="oggetto_sel.tipo_oggetto != 'D'"
                  hide-details
                  label="Dim. Font Dato"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model="oggetto_sel.font_size_dato"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col
                align="center"
                cols="3"
                v-if="
                  oggetto_sel.tipo_oggetto !== 'I' &&
                  oggetto_sel.text !== 'span'
                "
              >
                <!-- Campo di input del testo della tooltip
                  -- del bottone / titolo del dato. -->
                <v-text-field
                  dense
                  :readonly="oggetto_sel.tipo_oggetto == 'D' || oggetto_sel.tipo_oggetto === 'B'"
                  hide-details
                  :label="
                    oggetto_sel.tipo_oggetto === 'B' ? 'Tooltip' : 'Titolo'
                  "
                  outlined
                  style="border-radius: 0px"
                  v-model="oggetto_sel.tooltip"
                >
                </v-text-field>
              </v-col>
              <v-col align="center" cols="3" v-else>
                <!-- Campo di input del testo dell'intestazione -->
                <v-text-field
                  dense
                  hide-details
                  :label="
                    oggetto_sel.tipo_oggetto === 'B' ? 'Tooltip' : 'Titolo'
                  "
                  outlined
                  style="border-radius: 0px"
                  v-model="oggetto_sel.testo"
                >
                </v-text-field>
              </v-col>

              <v-col align="center" cols="3">
                <!-- Campo di input dello stile del font del titolo -->
                <v-select
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Font Titolo"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="oggetto_sel.font_weight_titolo"
                ></v-select>
              </v-col>
              <v-col align="center" cols="3">
                <!-- Campo di input dello stile del font del dato -->
                <v-select
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Font Dato"
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  v-model="oggetto_sel.font_weight_dato"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" justify="start">
              <v-col align="center" cols="4">
                <!-- Campo di input del colore del font del titolo -->
                <div>
                  <div>Colore Font Titolo</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: oggetto_sel.font_color_titolo,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="oggetto_sel.font_color_titolo"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
              <v-col align="center" cols="4">
                <!-- Campo di input del colore del font del dato -->
                <div>
                  <div>Colore Font Dato</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: oggetto_sel.font_color_dato,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="oggetto_sel.font_color_dato"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
              <v-col align="center" cols="4">
                <v-checkbox
                  color="primary"
                  :disabled="oggetto_sel.tipo_oggetto != 'D'"
                  :false-value="0"
                  label="Filtrabile"
                  :true-value="1"
                  v-model="oggetto_sel.filtrabile"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di salvataggio -->
    <v-dialog v-model="dialog_salvataggio">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Salvataggio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_salvataggio = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto"> </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di caricamento -->
    <v-dialog v-model="dialog_caricamento" width="70vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Caricamento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_caricamento = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-data-table
            :headers="headers_layout_caricabili"
            :items="items_layout_caricabili"
            sort-by="id_layout"
            sort-desc
          >
            <!-- Bottone di selezione del layout -->
            <template v-slot:[`item.seleziona`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-5"
                    @click="selectLayout(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>Seleziona Layout</span>
              </v-tooltip>
            </template>

            <!-- Bottone di duplicazione del layout -->
            <template v-slot:[`item.duplica`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-5"
                    @click="
                      copyLayout(
                        {
                          id_layout_tmp: item.id_layout,
                          titolo_layout_tmp: item.titolo,
                          modulo_layout_tmp: item.modulo,
                        },
                        'copy'
                      )
                    "
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary"> mdi-content-copy </v-icon>
                  </v-btn>
                </template>
                <span>Duplica Layout</span>
              </v-tooltip>
            </template>

            <!-- Colonna della data -->
            <template v-slot:[`item.data_ins`]="{ item }">
              {{ formatData(item.data_ins) }}
            </template>

            <!-- Bottone di eliminazione del layout -->
            <template v-slot:[`item.cancella`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-5"
                    @click="clickCancellaLayout(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Cancella Layout</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="overlay_carica_layout" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog persistent v-model="dialog_nuovo_layout" width="400px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Nuovo Layout</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickSalvaLayout" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_nuovo_layout = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Titolo"
                  style="max-width: 250px"
                  v-model="titolo_layout_tmp"
                >
                </v-text-field>
              </v-col>
              <v-col align="center" cols="6">
                <v-autocomplete
                  dense
                  hide-details
                  item-text="des"
                  item-value="des"
                  :items="[
                    { des: 'AVANZAMENTO' },
                    { des: 'SCELTAWO' },
                    { des: 'AUDITQC' },
                  ]"
                  label="Modulo"
                  style="max-width: 250px"
                  v-model="modulo_layout_tmp"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog tabella bottoni -->
    <v-dialog v-model="dialog_tabella_bottoni">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Lista bottoni </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_tabella_bottoni = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-data-table
            height="60vh"
            fixed-header
            :headers="headers_bottoni"
            :items="items_btn"
          >
            <!-- Colonna del modifica -->
            <template v-slot:[`item.modifica`]="{ item }">
              <v-btn
                @click="
                  dialog_modifica_bottone = true;
                  editButton($event, item);
                "
                small
                ><v-icon color="primary">mdi-pencil</v-icon></v-btn
              >
            </template>

            <!-- Colonna dell'icona -->
            <template v-slot:[`item.icona`]="{ item }">
              <v-btn class="ma-2" :color="item.colore_sfondo" small tile>
                <v-icon :color="item.colore_icona">{{ item.icona }}</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica dei bottoni -->
    <v-dialog v-model="dialog_modifica_bottone">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Bottone
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaBottone"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_bottone = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_colore_icona"
                  label="Colore Icona"
                  outlined
                  style="border-radius: 0px"
                  v-model="bottone_sel.colore_icona"
                >
                  <template v-slot:append>
                    <v-icon :color="bottone_sel.colore_icona">
                      mdi-square-rounded
                    </v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_colore_sfondo"
                  label="Colore Sfondo"
                  outlined
                  style="border-radius: 0px"
                  v-model="bottone_sel.colore_sfondo"
                >
                  <template v-slot:append>
                    <v-icon :color="bottone_sel.colore_sfondo">
                      mdi-square-rounded
                    </v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  label="Icona"
                  style="border-radius: 0px"
                  v-model="bottone_sel.icona"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Tooltip"
                  outlined
                  style="border-radius: 0px"
                  v-model="bottone_sel.tooltip"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col cols="11"
                ><v-textarea
                  readonly
                  outlined
                  no-resize
                  rows="3"
                  label="Pre query"
                  v-model="bottone_sel.prequery" /></v-col
              ><v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openDialogPrequery"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-database </v-icon>
                    </v-btn>
                  </template>
                  <span>Apri l'Editor</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col cols="11"
                ><v-textarea
                  readonly
                  outlined
                  no-resize
                  rows="3"
                  label="Post query"
                  v-model="bottone_sel.postquery" /></v-col
              ><v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openDialogPostquery"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-database </v-icon>
                    </v-btn>
                  </template>
                  <span>Apri l'Editor</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica dei dati -->
    <v-dialog v-model="dialog_modifica_dato" width="500">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Dato
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaModificaDato" small v-bind="attrs" v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_dato = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  label="Tooltip"
                  style="border-radius: 0px"
                  v-model="bottone_sel.tooltip"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  label="Value"
                  style="border-radius: 0px"
                  v-model="bottone_sel.value"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay_carica_layout" style="z-index: 10">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica delle notifiche -->
    <v-dialog v-model="dialog_modifica_notifica">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Notifica
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaNotifica"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon></v-btn
              >
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica_notifica = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="start">
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Titolo"
                  outlined
                  style="border-radius: 0px"
                  v-model="oggetto_sel.text"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Testo"
                  outlined
                  style="border-radius: 0px"
                  v-model="oggetto_sel.tooltip"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col align="center" cols="3">
                <!-- Campo di input del colore del font del dato -->
                <div>
                  <div>Colore Testo</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: oggetto_sel.font_color_dato,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="oggetto_sel.font_color_dato"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <v-col align="center" cols="3">
                <!-- Campo di input del colore dello sfondo della colonna -->
                <div>
                  <div>Sfondo Colonna</div>
                  <div>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          :style="{
                            backgroundColor: oggetto_sel.colore_sfondo,
                            border: '1px solid black',
                            display: 'inline-block',
                            height: '35px',
                            width: '35px',
                            borderRadius: '5px',
                            marginLeft: '15px',
                            marginRight: '15px',
                          }"
                          v-bind="attrs"
                          v-on="on"
                        ></div>
                      </template>
                      <v-color-picker
                        v-model="oggetto_sel.colore_sfondo"
                        dot-size="25"
                        hide-canvas
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="200"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Dimensione Testo"
                  outlined
                  style="border-radius: 0px"
                  type="number"
                  v-model.number="oggetto_sel.font_size_dato"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_font_weight"
                  item-text="text"
                  item-value="value"
                  label="Stile Testo"
                  outlined
                  style="border-radius: 0px"
                  v-model="oggetto_sel.font_weight_dato"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog delle associazioni -->
    <v-dialog persistent v-model="dialog_associazioni" width="500px">
      <AssociazioniLayout
        @click_chiudi="dialog_associazioni = false"
        :id_layout_sel="
          colonne.length > 0 && colonne[0].id_layout > 0
            ? colonne[0].id_layout
            : -1
        "
        @salvate_associazioni="handleSalvateAssociazioni"
        :visible="dialog_associazioni"
      />
    </v-dialog>

    <!-- Dialog delle operazioni -->
    <v-dialog v-model="dialog_operazioni">
      <AggiungiOperazione
        @click_indietro="dialog_operazioni = false"
        v-if="dialog_operazioni"
      />
    </v-dialog>

    <!-- Dialog di verifica query pre -->
    <v-dialog persistent v-model="dialog_query_pre" width="90%">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            referrerpolicy="origin"
            @chiudi_dialog="dialog_query_pre = false"
            @conferma_query="assegna_pre"
            :component="'query'"
            ref="windowframe_query"
            :input_args="input_args"
            :key="key_windowframe_prequery"
            @loaded="handleLoaded('prequery')"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di verifica query post -->
    <v-dialog persistent v-model="dialog_query_post" width="700px">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            referrerpolicy="origin"
            @chiudi_dialog="dialog_query_post = false"
            @conferma_query="assegna_post"
            :component="'query'"
            ref="windowframe_query"
            :input_args="input_args"
            :key="key_windowframe_postquery"
            @loaded="handleLoaded('postquery')"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di verifica query principale -->
    <v-dialog persistent v-model="dialog_query_principale" width="80vw">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            referrerpolicy="origin"
            @chiudi_dialog="dialog_query_principale = false"
            @conferma_query="assegnaQueryPrincipale"
            :component="'query'"
            ref="windowframe_query"
            :input_args="input_args"
            :key="key_windowframe_principale"
            @loaded="handleLoaded('principale')"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di importazione -->
    <v-dialog persistent v-model="dialog_importa_layout" width="500px">
      <v-card>
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">
            Importazione Layout
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_importa_layout = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table
          :headers="headers_importazione"
          :items="items_importazione"
        >
          <!-- Bottone di scelta importazione del layout -->
          <template v-slot:[`item.seleziona`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="
                    copyLayout(
                      {
                        id_layout_tmp: item.id_layout,
                        titolo_layout_tmp: item.titolo,
                        modulo_layout_tmp: item.modulo,
                      },
                      'import'
                    )
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </template>
              <span>Seleziona Layout</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import AggiungiOperazione from "@/components/OPERAZIONI/AggiungiOperazione.vue";
import AssociazioniLayout from "@/components/LAYOUT/AssociazioniLayout.vue";
import ColumnObject from "@/classes/ColumnObject.js";
import DetailObject from "@/classes/DetailObject.js";
import draggable from "vuedraggable";
import LayoutRow from "@/components/LAYOUT/LayoutRow.vue";
import moment from "moment/moment";
import RowObject from "@/classes/RowObject.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

class Bottone {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "colore_icona", default_val: "#000000" },
      { nome: "colore_sfondo", default_val: "#FFFFFF" },
      { nome: "icona", default_val: "" },
      { nome: "id_header", default_val: -1 },
      { nome: "postquery", default_val: "" },
      { nome: "prequery", default_val: "" },
      { nome: "tooltip", default_val: "" },
      { nome: "value", default_val: "" },
    ];

    return campi;
  }
}

export default {
  name: "LayoutEditor",

  components: {
    AggiungiOperazione,
    AssociazioniLayout,
    draggable,
    LayoutRow,
    SnackbarQV,
    WindowFrame,
  },
  props: {
    rotta_back: { type: String, default: "/home/production" },
  },
  computed: {
    items_operazioni_used() {
      const arr_res = new Array();
      this.retreiveOperazioni(arr_res, this.colonne);
      return arr_res;
    },
  },
  data() {
    return {
      queryType: 0,
      sentQuery: 0,
      // Variabili d'appoggio
      bottone_sel: new Bottone(),
      colonna_sel: new ColumnObject(),
      colonna_tmp: new ColumnObject(),
      creation_mode: "new",
      cursor_x: 0,
      cursor_y: 0,
      drag_state: "off",
      id_layout_tmp: null,
      input_args: {},
      key_rows: 0,
      key_windowframe_prequery: 0,
      key_windowframe_postquery: 0,
      key_windowframe_principale: 0,
      modalita_selezione: "colonna",
      modulo_layout_sel: "",
      modulo_layout_tmp: "",
      oggetto_sel: new DetailObject(),
      query_layout_sel: "",
      riga_sel: new RowObject(),
      riga_tmp: new RowObject(),
      titolo_layout_sel: null,
      titolo_layout_tmp: "",
      tooltip_delay: 15,

      // Modal
      dialog_associazioni: false,
      dialog_caricamento: false,
      dialog_importa_layout: false,
      dialog_modifica_bottone: false,
      dialog_modifica_dato: false,
      dialog_modifica_info: false,
      dialog_tabella_bottoni: false,
      dialog_modifica_colonna: false,
      dialog_modifica_notifica: false,
      dialog_modifica_oggetto: false,
      dialog_modifica_riga: false,
      dialog_nuovo_layout: false,
      dialog_operazioni: false,
      dialog_query_pre: false,
      dialog_query_post: false,
      dialog_query_principale: false,
      dialog_salvataggio: false,
      overlay: false,
      overlay_carica_layout: false,

      // Array
      colonne: [new ColumnObject()],
      headers_layout_caricabili: [
        {
          text: "Seleziona",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        {
          text: "Duplica",
          value: "duplica",
          sortable: false,
          width: "100px",
        },
        {
          text: "Titolo",
          value: "titolo",
          sortable: false,
        },
        {
          text: "Modulo",
          value: "modulo",
          sortable: false,
        },
        {
          text: "Data",
          value: "data_ins",
          sortable: false,
          width: "200px",
        },
        {
          text: "Cancella",
          value: "cancella",
          sortable: false,
          width: "100px",
        },
      ],
      headers_bottoni: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Icona",
          value: "icona",
          sortable: false,
        },
        {
          text: "Tooltip",
          value: "tooltip",
          sortable: false,
        },
        {
          text: "Query pre",
          value: "prequery",
          sortable: false,
        },
        {
          text: "Query post",
          value: "postquery",
          sortable: false,
        },
      ],
      headers_importazione: [
        {
          text: "Seleziona",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        {
          text: "Titolo",
          value: "titolo",
          sortable: false,
        },
        {
          text: "Modulo",
          value: "modulo",
          sortable: false,
        },
      ],
      items_btn: new Array(),
      items_colore_icona: [
        { text: "rosso", value: "#FD0000" },
        { text: "rossiccio", value: "error" },
        { text: "arancione", value: "orange" },
        { text: "giallo", value: "#ffcc00" },
        { text: "verde", value: "success" },
        { text: "azzurro", value: "primary" },
        { text: "blu", value: "primary" },
        { text: "grigetto", value: "grey lighten-5" },
        { text: "viola", value: "purple" },
        { text: "bianco", value: "#FFFFFF" },
        { text: "nero", value: "#000000" },
      ],
      items_colore_sfondo: [
        { text: "rosso", value: "#FD0000" },
        { text: "rossiccio", value: "error" },
        { text: "arancione", value: "orange" },
        { text: "giallo", value: "#ffcc00" },
        { text: "verde", value: "success" },
        { text: "azzurro", value: "primary" },
        { text: "blu", value: "indigo" },
        { text: "grigetto", value: "grey lighten-5" },
        { text: "viola", value: "purple" },
        { text: "bianco", value: "#FFFFFF" },
        { text: "nero", value: "#000000" },
      ],
      items_colore_sfondo_notifiche: [
        { text: "rosso", value: "#FD0000" },
        { text: "rossiccio", value: "#ff5252" },
        { text: "arancione", value: "#ff6600" },
        { text: "verde", value: "#4caf50" },
        { text: "azzurro", value: "#1976d2" },
        { text: "blu", value: "#3f51b5" },
        { text: "grigetto", value: "#ECEFF1" },
        { text: "bianco", value: "#FFFFFF" },
        { text: "nero", value: "#000000" },
      ],
      items_elementi: new Array(),
      items_font_weight: [
        {
          text: "Normale",
          value: "normal",
        },
        {
          text: "Grassetto",
          value: "bold",
        },
      ],
      items_importazione: new Array(),
      items_info: new Array(),
      items_layout_caricabili: new Array(),
      items_notifiche: new Array(),
      operazioni: new Array(),
    };
  },
  watch: {
    drag_state: {
      immediate: true,
      handler() {
        /* Quando il drag_state passa a 'on' associo al contenitore
         * generale la funzione per aggiornare le coordinate registrate
         * del cursore. Quando passa a 'off' rimuovo l'evento. */
        if (this.drag_state === "on") {
          document
            .getElementById("listener_layout")
            ?.addEventListener("mousemove", this.updateCursorCoordinates);
        } else if (this.drag_state === "off") {
          document
            .getElementById("listener_layout")
            ?.removeEventListener("mousemove", this.updateCursorCoordinates);
        }
      },
    },
  },
  methods: {
    handleLoaded(arg) {
      switch (arg) {
        case "preqeury":
          this.$refs.windowframe_query.postEvent(
            "setquery",
            this.bottone_sel.prequery
          );
          break;
        case "postquery":
          this.$refs.windowframe_query.postEvent(
            "setquery",
            this.bottone_sel.postquery
          );
          break;
        case "principale":
          this.$refs.windowframe_query.postEvent(
            "setquery",
            this.query_layout_sel
          );
          break;
        default:
          break;
      }
    },
    addCol() {
      const obj_tmp = new ColumnObject();
      obj_tmp.ordine = this.riga_sel.colonne.length + 1;
      obj_tmp.id_padre_tmp = this.riga_sel.id_layout_struttura_tmp;
      obj_tmp.id_layout = this.riga_sel.id_layout;

      this.$set(this.riga_sel.colonne, this.riga_sel.colonne.length, obj_tmp);
      this.key_rows = this.key_rows === 0 ? 1 : 0;
    },
    addRow() {
      /* Se il titolo è nullo, vuol dire che non ho caricato
       * un layout e non sto generando un nuovo layout, sono
       * solo entrato nella vista e ho cominciato a cliccare a caso.
       * Se è così dico all'utente di creare un layout prima di
       * editare la dashboard. */
      if (this.titolo_layout_sel === null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Creare un nuovo layout o caricarlo prima di modificare la dashboard."
        );
        return;
      }

      // Genero una riga nuova.
      const obj_tmp = new RowObject();
      obj_tmp.ordine = this.colonna_sel.righe.length + 1;
      obj_tmp.id_padre_tmp = this.colonna_sel.id_layout_struttura_tmp;
      obj_tmp.id_layout = this.colonna_sel.id_layout;
      obj_tmp.colonne = [
        new ColumnObject({
          id_layout: this.colonna_sel.id_layout,
          id_layout_struttura_tmp: -moment().valueOf() - 1,
          id_padre_tmp: obj_tmp.id_layout_struttura_tmp,
          ordine: obj_tmp.colonne.length + 1,
        }),
      ];

      // Inserisco la riga appena creata nella dashboard.
      this.$set(this.colonna_sel.righe, this.colonna_sel.righe.length, obj_tmp);
      this.key_rows = this.key_rows === 0 ? 1 : 0;
    },
    aggiungiNotifica() {
      this.oggetto_sel = new DetailObject();
      this.oggetto_sel.tipologia = "notifica";
      this.oggetto_sel.tipo_oggetto = "N";
      this.dialog_modifica_notifica = true;
    },
    assegnaOrdine(arg) {
      for (let i = 0; i < arg.length; i++) {
        if (arg[i].validita == 1) {
          arg[i].ordine = i + 1;
        }
      }
    },

    assegnaQueryPrincipale(value) {
      this.query_layout_sel = value.query;
    },
    assegna_post(value) {
      this.bottone_sel.postquery = value;
    },

    assegna_pre(value) {
      this.bottone_sel.prequery = value;
    },

    associaElemento(arg_dove, arg_cosa) {
      let font_color_dato_tmp = this.oggetto_sel.font_color_dato;

      for (let c = 0; c < arg_dove.length; c++) {
        if (arg_dove[c].id_layout_struttura_tmp === arg_cosa) {
          /* Uso le impostazioni della colonna
           * per definire l'aspetto dell'elemento. */
          for (let field in arg_dove[c]) {
            if (
              field === "font_color_dato" ||
              field === "font_color_titolo" ||
              field === "font_size_icona" ||
              field === "font_size_dato" ||
              field === "font_size_titolo" ||
              field === "font_weight_dato" ||
              field === "font_weight_titolo"
            ) {
              this.oggetto_sel[field] = arg_dove[c][field];
            }
          }

          if (this.oggetto_sel.tipologia === "notifica") {
            this.oggetto_sel.font_color_dato = font_color_dato_tmp;
          }

          this.oggetto_sel.id_padre_tmp = arg_cosa;

          /* Tolgo validita agli oggetti che eventualmente erano già nella colonna,
           * se l'oggetto che ho spostato non è un pulsante. */
          if (this.oggetto_sel.tipologia != "v-btn") {
            arg_dove[c].oggetto.forEach((o) => {
              this.$set(o, "validita", 0);
            });
          }

          /* Faccio un oggetto temporanero che mediante l'uso della classe
           * DetailObject garantisce che tutti gli oggetti abbiano la stessa
           * struttura (altrimenti si riscontrano delle differenze fra dati
           * e bottoni in sede di set che creano difficoltà al BE). */
          const obj_tmp = new DetailObject(this.oggetto_sel);

          // Inserisco il nuovo oggetto.
          this.$set(arg_dove[c].oggetto, arg_dove[c].oggetto.length, obj_tmp);

          // Resetto le variabili di supporto e forzo l'aggiornamento grafico.
          this.oggetto_sel = new DetailObject();
          this.drag_state = "off";
          this.key_rows = this.key_rows === 0 ? 1 : 0;
          return;
        } else {
          for (let r = 0; r < arg_dove[c].righe.length; r++) {
            this.associaElemento(arg_dove[c].righe[r].colonne, arg_cosa);
          }
        }
      }
    },
    buildDuplicateColumn(arg, increment) {
      /* Questa colonna e qualcuna delle colonne contenute
       * nelle righe di questa colonna potrebbero essere generate
       * nello stesso millisecondo e ciò comporterebbe di avere
       * colonne con identificativi duplicati. Per evitare la
       * duplicazione degli identificativi uso un incrementatore
       * progressivo che dovrebbe dare una certa garanzia di univocità.
       * Questo è lo scopo dell'argomento "increment" della funzione. */
      increment++;

      // Riassegno gli identificativi alla colonna.
      arg.id_layout_struttura = -1;
      arg.id_layout_struttura_tmp = -moment().valueOf() - increment;
      arg.oggetto = new Array();

      /* Resetto le proprietà e gli identificativi delle
       * righe eventualmente presenti nella colonna. */
      for (let r = 0; r < arg.righe.length; r++) {
        arg.righe[r].id_layout_struttura = -1;
        arg.righe[r].id_layout_struttura_tmp =
          -moment().valueOf() - increment - arg.righe.length - r - 1;
        arg.righe[r].id_padre_tmp = arg.id_layout_struttura_tmp;

        /* Applico ricorsivamente questa funzione a tutte le
         * colonne della riga che ho appena resettato. */
        for (let c = 0; c < arg.righe[r].colonne.length; c++) {
          increment++;
          this.buildDuplicateColumn(arg.righe[r].colonne[c], increment);
        }
      }
    },
    buildDuplicateRow(arg, increment) {
      /* Questa colonna e qualcuna delle colonne contenute
       * nelle righe di questa colonna potrebbero essere generate
       * nello stesso millisecondo e ciò comporterebbe di avere
       * colonne con identificativi duplicati. Per evitare la
       * duplicazione degli identificativi uso un incrementatore
       * progressivo che dovrebbe dare una certa garanzia di univocità.
       * Questo è lo scopo dell'argomento "increment" della funzione. */
      increment++;

      // Riassegno gli identificativi al row.
      arg.id_layout_struttura = -1;
      arg.id_layout_struttura_tmp = -moment().valueOf() - increment;

      /* Resetto le proprietà e gli identificativi delle
       * colonne eventualmente presenti nella riga. Applico
       * una serie di sottrazioni basate su valori dinamici
       * che dovrebbero garantirmi univocità degli identificativi. */
      for (let c = 0; c < arg.colonne.length; c++) {
        arg.colonne[c].id_layout_struttura = -1;
        arg.colonne[c].id_layout_struttura_tmp =
          -moment().valueOf() - increment - arg.colonne.length - c - 1;
        arg.colonne[c].oggetto = new Array();
        arg.colonne[c].id_padre_tmp = arg.id_layout_struttura_tmp;

        /* Applico ricorsivamente questa funzione a tutte le
         * righe della colonna che ho appena resettato. */
        for (let r = 0; r < arg.colonne[c].righe.length; r++) {
          increment++;
          this.buildDuplicateRow(arg.colonne[c].righe[r], increment);
        }
      }
    },

    checkIdLayout(arg_arr) {
      for (let c = 0; c < arg_arr.length; c++) {
        if (arg_arr[c].oggetto) {
          for (let o = 0; o < arg_arr[c].oggetto.length; o++) {
            arg_arr[c].oggetto[o].id_layout = arg_arr[c].id_layout;
          }
        }

        for (let r = 0; r < arg_arr[c].righe.length; r++) {
          this.checkIdLayout(arg_arr[c].righe[r].colonne);
        }
      }
    },
    clearLayout(arg) {
      arg.forEach((c) => {
        c.id_layout = -1;
        c.oggetto = new Array();
        c.righe.forEach((r) => {
          r.id_layout = -1;
          r.id_layout_dettaglio = -1;
          this.clearLayout(r.colonne);
        });
      });
    },
    clickAssociazioneProfili() {
      /* Devo mostrare quali profili sono associati al
       * layout che sto guardando. Se non ho ancora
       * selezionato il layout, stampo un avviso e mi fermo. */
      if (this.colonne.length == 0 || parseInt(this.colonne[0].id_layout) < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare un layout per vederne le associazioni."
        );
        return;
      }

      this.dialog_associazioni = true;
    },
    clickCancellaLayout(arg) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setlayout",
          token: localStorage.user_token,
          layout: [{ id_layout: arg.id_layout, validita: 0 }],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Layout cancellato con successo."
            );

            this.getLayout();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    async clickCaricaDialog() {
      this.overlay = true;
      await this.getLayout();
      this.overlay = false;

      this.dialog_caricamento = true;
    },
    clickCopyLayout(arg) {
      /* Registro l'id del layout selezionato e apro la
       * finestra di dialogo per inserire il nuovo titolo. */
      this.creation_mode = "copy";
      this.titolo_layout_tmp = "";
      this.modulo_layout_tmp = "";
      this.id_layout_tmp = arg.id_layout;
      this.dialog_nuovo_layout = true;
    },
    clickImportaLayout() {
      this.dialog_importa_layout = true;
    },
    clickNewLayout() {
      this.creation_mode = "new";
      this.titolo_layout_tmp = "";
      this.modulo_layout_tmp = "";
      this.dialog_nuovo_layout = true;
    },
    clickSalvaLayout() {
      if (this.creation_mode === "new") {
        this.salvaNuovoLayout();
      } else {
        this.copyLayout(
          {
            id_layout_tmp: this.id_layout_tmp,
            titolo_layout_tmp: this.titolo_layout_tmp,
            modulo_layout_tmp: this.modulo_layout_tmp,
          },
          "copy"
        );
      }
    },
    cloneColumn(arg) {
      const obj_tmp = new ColumnObject(arg);
      /* Cancello gli oggetti eventualmente presenti
       * in questa riga e nei suoi figli. */
      this.buildDuplicateColumn(obj_tmp, 1);

      // Aggiungo la colonna alla dashboard.
      this.riga_sel.colonne.push(obj_tmp);
      this.assegnaOrdine(this.riga_sel.colonne);
      this.key_rows = this.key_rows === 0 ? 1 : 0;
    },
    copyLayout(arg_layout, arg_modalita) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "copylayout",
          token: localStorage.user_token,
          id_layout: arg_layout.id_layout_tmp,
          titolo: arg_layout.titolo_layout_tmp,
          modulo: arg_layout.modulo_layout_tmp,
        },
      };

      /* Imposto gli eventuali parametri di import;
       * Se non sto importando questi parametri non
       * devono essere presenti nella request. */
      if (arg_modalita === "import") {
        request.richiesta.db_src = "db_master";
        request.richiesta.db_dst = localStorage.dbname;
      }

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            /* Se stavo copiando aggiorno la lista dei layout,
             * se stavo importando chiudo la finestra di
             * importazione e stampo una snackbar di conferma. */
            if (arg_modalita === "copy") {
              this.getLayout();
              this.dialog_nuovo_layout = false;
            } else {
              this.$refs.SnackbarQV.print(
                "success",
                "Layout copiato con successo."
              );
              this.dialog_importa_layout = false;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    cloneRow(arg) {
      const obj_tmp = new RowObject(arg);
      /* Cancello gli oggetti eventualmente presenti
       * in questa riga e nei suoi figli. */
      this.buildDuplicateRow(obj_tmp, 1);

      // Aggiungo la riga alla dashboard.
      this.colonna_sel.righe.push(obj_tmp);
      this.assegnaOrdine(this.colonna_sel.righe);
      this.key_rows = this.key_rows === 0 ? 1 : 0;
    },
    copyLayoutToClipboard() {
      // Controllo che ci sia almeno una riga da copiare.
      if (this.colonne[0].righe.length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La struttura del layout è vuota."
        );
        return;
      }

      // Registro la struttura del mio layout.
      const arr_tmp = [new ColumnObject(this.colonne[0])];

      // Rimuovo gli oggetti (i dettagli) dalla struttura del layout.
      this.clearLayout(arr_tmp);

      /* Faccio una textarea temporanea e la uso per metterci
       * dentro la versione stringa della mia dashboard, per
       * poi copiarla nella clipboard. */
      const textarea = document.createElement("textarea");
      document.body.appendChild(textarea);
      textarea.value = JSON.stringify(arr_tmp);
      textarea.select();
      document.execCommand("copy");

      // Rimuovo la textarea temporanea.
      document.body.removeChild(textarea);

      // Stampo un messaggio di successo.
      this.$refs.SnackbarQV.print(
        "success",
        "Struttura copiata negli appunti."
      );
    },
    deleteColumn(arg_dove, arg) {
      for (let c = 0; c < arg_dove.length; c++) {
        if (
          arg_dove[c].id_layout_struttura_tmp === arg.id_layout_struttura_tmp
        ) {
          this.$set(arg_dove[c], "validita", 0);
          this.assegnaOrdine(arg_dove);
          this.key_rows = this.key_rows === 0 ? 1 : 0;
          return;
        } else {
          for (let r = 0; r < arg_dove[c].righe.length; r++) {
            this.deleteColumn(arg_dove[c].righe[r].colonne, arg);
          }
        }
      }
    },
    deleteNullColumns(arg) {
      for (let c = 0; c < arg.length; c++) {
        for (let r = 0; c < arg[c].righe.length; r++) {
          arg[c].righe[r].colonne = arg[c].righe[r].colonne.filter(
            (col) => col.validita === 1 || col.id_layout_struttura > 0
          );
          this.deleteNullColumns(arg[c].righe[r].colonne);
        }
      }
    },
    deleteNullDetails(arg) {
      for (let c = 0; c < arg.length; c++) {
        arg[c].oggetto = arg[c].oggetto.filter(
          (o) => o.validita === 1 || o.id_layout_dettaglio > 0
        );

        for (let r = 0; r < arg[c].righe.length; r++) {
          this.deleteNullDetails(arg[c].righe[r].colonne);
        }
      }
    },
    deleteNullRows(arg) {
      for (let c = 0; c < arg.length; c++) {
        arg[c].righe = arg[c].righe.filter((r) => {
          r.validita === 1 || r.id_layout_struttura > 0;
        });

        for (let r = 0; c < arg[c].righe.length; r++) {
          this.deleteNullColumns(arg[c].righe[r].colonne);
        }
      }
    },
    deleteObject(arg_dove, nome_campo, arg) {
      for (let c = 0; c < arg_dove.length; c++) {
        if (arg_dove[c].oggetto.length > 0) {
          for (let o = 0; o < arg_dove[c].oggetto.length; o++) {
            if (arg_dove[c].oggetto[o][nome_campo] === arg) {
              this.$set(arg_dove[c].oggetto[o], "validita", 0);
              this.key_rows = this.key_rows === 0 ? 1 : 0;
            }
          }
        } else {
          for (let r = 0; r < arg_dove[c].righe.length; r++) {
            this.deleteObject(arg_dove[c].righe[r].colonne, nome_campo, arg);
          }
        }
      }
    },
    deleteRow(arg_dove, arg) {
      for (let c = 0; c < arg_dove.length; c++) {
        for (let r = 0; r < arg_dove[c].righe.length; r++) {
          if (
            arg_dove[c].righe[r].id_layout_struttura_tmp ===
            arg.id_layout_struttura_tmp
          ) {
            this.$set(arg_dove[c].righe[r], "validita", 0);
            this.assegnaOrdine(arg_dove[c].righe);
            this.key_rows = this.key_rows === 0 ? 1 : 0;
            return;
          } else {
            this.deleteRow(arg_dove[c].righe[r].colonne, arg);
          }
        }
      }
    },
    editButton(e, arg) {
      e.preventDefault();
      this.bottone_sel = new Bottone(arg);
      this.dialog_modifica_bottone = true;
    },
    editColumn(arg) {
      this.colonna_tmp = new ColumnObject(arg);
      this.dialog_modifica_colonna = true;
    },
    editDatum(e, arg) {
      e.preventDefault();

      /* Questo non è un bottone, ma non importa:
       * posso comunque usare la classe perché la
       * struttura dell'oggetto è simile. */
      this.bottone_sel = new Bottone(arg);
      console.log(JSON.stringify(this.bottone_sel));
      this.dialog_modifica_dato = true;
    },
    editNotification(e, arg) {
      /* Se mi è stato passato un evento, ne prevengo la
       * propagazione agli elementi superiori del layout. */
      if (e) {
        e.preventDefault();
      }

      this.oggetto_sel = new DetailObject(arg);
      this.oggetto_sel.font_color_dato = arg.colore_icona;
      this.dialog_modifica_notifica = true;
    },
    editObject(arg) {
      this.oggetto_sel = new DetailObject(arg);
      this.dialog_modifica_oggetto = true;
    },
    editRow(arg) {
      this.riga_tmp = new RowObject(arg);
      this.dialog_modifica_riga = true;
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        return strRes;
      }
    },
    formatObjects(arr) {
      // Pero ogni colonna di questo array...
      for (let c = 0; c < arr.length; c++) {
        // ... Se ha degli oggetti...
        if (arr[c].oggetto) {
          // ... Controlla la struttura di ogni oggetto.
          for (let o = 0; o < arr[c].oggetto.length; o++) {
            this.$set(arr[c].oggetto, o, new DetailObject(arr[c].oggetto[o]));
          }
        }

        // Se ci sono righe nella colonna...
        if (arr[c].righe) {
          // ... Per ogni riga...
          for (let r = 0; r < arr[c].righe.length; r++) {
            // ... Se la riga contiene colnne...
            if (arr[c].righe[r].colonne) {
              // ... Lancia questa funzione su ogni colonna.
              this.formatObjects(arr[c].righe[r].colonne);
            }
          }
        }
      }
    },
    getLayout() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayout",
          token: localStorage.user_token,
          nome_modulo: "AVANZAMENTO",
          // nome_modulo: "ALLEGATO",
          id_profilo: "",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // Registro i layout disponibili.
            this.items_layout_caricabili = res.data.result.layout;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getLayoutDettaglio() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          nome_modulo: this.modulo_layout_sel,
          // nome_modulo: "ALLEGATO",
          id_profilo: "",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // ... Preparo gli array dei bottoni e delle informazioni...
            const arr_btn_tmp = new Array();
            const arr_info_tmp = new Array();
            const arr_elementi_tmp = new Array();
            const arr_notifiche_tmp = new Array();

            /* ... Popolo i miei array usando l'incrementatore "increment"
             * per evitare di avere identificativi duplicati ... */
            let increment = 1;
            res.data.forEach((e) => {
              if (e.tipo_oggetto === "B") {
                const obj_tmp = new DetailObject(e);
                obj_tmp.id_layout = this.colonne[0].id_layout;
                obj_tmp.id_header = e.id_header;
                obj_tmp.prequery = e.prequery;
                obj_tmp.postquery = e.postquery;
                obj_tmp.id_layout_dettaglio = -1;
                obj_tmp.id_layout_dettaglio_tmp =
                  -moment().valueOf() - increment;
                obj_tmp.tipologia = "v-btn";
                arr_btn_tmp.push(obj_tmp);
                increment++;
              } else if (e.tipo_oggetto === "D") {
                const obj_tmp = new DetailObject(e);
                obj_tmp.id_layout = this.colonne[0].id_layout;
                obj_tmp.id_header = e.id_header;
                obj_tmp.id_layout_dettaglio = -1;
                obj_tmp.id_layout_dettaglio_tmp =
                  -moment().valueOf() - increment;
                obj_tmp.tipologia = "span";
                obj_tmp.value = e.value;
                arr_info_tmp.push(obj_tmp);
                increment++;
              } else if (e.tipo_oggetto === "I") {
                const obj_tmp = new DetailObject(e);
                obj_tmp.id_layout = this.colonne[0].id_layout;
                obj_tmp.id_header = e.id_header;
                obj_tmp.id_layout_dettaglio = -1;
                obj_tmp.id_layout_dettaglio_tmp =
                  -moment().valueOf() - increment;
                obj_tmp.tipologia = e.text;
                obj_tmp.testo = e.tooltip;
                arr_elementi_tmp.push(obj_tmp);
                increment++;
              } else if (e.tipo_oggetto === "N") {
                const obj_tmp = new DetailObject(e);
                obj_tmp.id_layout = this.colonne[0].id_layout;
                obj_tmp.id_header = e.id_header;
                obj_tmp.id_layout_dettaglio = -1;
                obj_tmp.id_layout_dettaglio_tmp =
                  -moment().valueOf() - increment;
                obj_tmp.tipologia = "notifica";
                arr_notifiche_tmp.push(obj_tmp);
                increment++;
              }
            });
            // ... Controllo che siano ordinati...
            arr_btn_tmp.sort((a, b) => a.ordine - b.ordine);
            arr_info_tmp.sort((a, b) => a.ordine - b.ordine);
            arr_elementi_tmp.sort((a, b) => a.ordine - b.ordine);
            arr_notifiche_tmp.sort((a, b) => a.ordine - b.ordine);

            // ... E li registro nelle variabili di supporto del componente.
            this.items_btn = arr_btn_tmp;
            this.items_info = arr_info_tmp;
            this.items_elementi = arr_elementi_tmp;
            this.items_notifiche = arr_notifiche_tmp;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getLayoutStandard() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutstandard",
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_importazione = res.data.result.layout;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          return false;
        });
    },
    getLayoutStruttura(arg) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutstruttura",
          token: localStorage.user_token,
          id_layout: arg.id_layout,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            const arr_tmp = [new ColumnObject(res.data.result)];

            /* Se il layout è vuoto, di per sé il BE non me lo restituisce con un
             * id_layout e id_layout_tmp quindi per evitare che il layout sia privo
             * di questi campi che servono per il salvataggio corretto gli assegno
             * l'id_layout e l'id_layout_tmp dell'oggetto che ho usato per la chiamata. */
            arr_tmp[0].id_layout = arg.id_layout;
            arr_tmp[0].id_layout_tmp = arg.id_layout_tmp;

            this.formatObjects(arr_tmp);

            this.resetSelection(arr_tmp);

            // Registro la struttura del layout.
            this.$set(this.colonne, 0, new ColumnObject(arr_tmp[0]));
            this.goToRoot();

            // Registro il titolo del layout selezionato.
            this.titolo_layout_sel = arg.titolo;
            this.query_layout_sel = arg.query;

            // Chiudo il dialog di caricamento.
            this.dialog_caricamento = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getOperazioni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getoperazionifull",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.operazioni = res.data.result.operazioni;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati delle operazioni."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati delle operazioni."
          );
        });
    },
    getUpdatedNotifications() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          nome_modulo: "AVANZAMENTO",
          // nome_modulo: "ALLEGATO",
          id_profilo: "",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // ... Preparo l'array delle notifiche...
            const arr_notifiche_tmp = new Array();

            /* ... Popolo l'array usando l'incrementatore "increment"
             * per evitare di avere identificativi duplicati ... */
            let increment = 1;
            res.data.forEach((e) => {
              if (e.tipo_oggetto === "N") {
                const obj_tmp = new DetailObject(e);
                obj_tmp.id_layout = this.colonne[0].id_layout;
                obj_tmp.id_header = e.id_header;
                obj_tmp.id_layout_dettaglio = -1;
                obj_tmp.id_layout_dettaglio_tmp =
                  -moment().valueOf() - increment;
                obj_tmp.tipologia = "notifica";
                arr_notifiche_tmp.push(obj_tmp);
                increment++;
              }
            });
            // ... Controllo che siano ordinati...
            arr_notifiche_tmp.sort((a, b) => a.ordine - b.ordine);

            // ... E li registro nelle variabili di supporto del componente.
            this.items_notifiche = arr_notifiche_tmp;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    goBack() {
      this.$router.push(this.rotta_back);
    },
    goToRoot() {
      if (this.modalita_selezione === "colonna") {
        this.colonna_sel.selezionata = 0;
        this.colonna_sel = this.colonne[0];
      } else if (this.modalita_selezione === "riga") {
        this.riga_sel.selezionata = 0;
        this.modalita_selezione = "colonna";
        this.colonna_sel = this.colonne[0];
      }
    },
    goUp(arg) {
      if (arg.tipologia === "colonna") {
        this.colonna_sel.selezionata = 0;
        this.ricercaRiga(this.colonne, arg.id_padre_tmp);
      } else if (arg.tipologia === "riga") {
        this.riga_sel.selezionata = 0;
        this.ricercaColonna(this.colonne, arg.id_padre_tmp);
      }
    },
    handleClickedColumn(arg) {
      this.colonna_sel.selezionata = 0;
      this.riga_sel.selezionata = 0;
      this.ricercaColonna(this.colonne, arg.detail.id_layout_struttura_tmp);
    },
    handleClickedRow(arg) {
      this.colonna_sel.selezionata = 0;
      this.riga_sel.selezionata = 0;

      this.ricercaRiga(this.colonne, arg.detail.id_layout_struttura_tmp);
    },
    handleContextMenuObject(arg) {
      this.colonna_sel.selezionata = 0;
      this.riga_sel.selezionata = 0;

      // Ricerco la colonna per renderla la nuova colonna selezionata.
      this.ricercaColonna(this.colonne, arg.detail.id_layout_struttura_tmp);

      /* Apro la finestra di dialogo per modificare l'oggetto
       * della colonna che ho appena selezionato. */
      this.editObject(
        this.colonna_sel.oggetto.filter((o) => o.validita === 1)[0]
      );
    },
    handleContextMenuColumn(arg) {
      this.colonna_sel.selezionata = 0;
      this.riga_sel.selezionata = 0;

      // Ricerco la colonna per renderla la nuova colonna selezionata.
      this.ricercaColonna(this.colonne, arg.detail.id_layout_struttura_tmp);

      /* Apro la finestra di dialogo per modificare
       * la colonna che ho appena selezionato. */
      this.editColumn(this.colonna_sel);
    },
    handleContextMenuRow(arg) {
      this.colonna_sel.selezionata = 0;
      this.riga_sel.selezionata = 0;

      // Ricerco la riga per renderla la nuova colonna selezionata.
      this.ricercaRiga(this.colonne, arg.detail.id_layout_struttura_tmp);

      /* Apro la finestra di dialogo per modificare
       * la colonna che ho appena selezionato. */
      this.editRow(this.riga_sel);
    },
    handleEndOfDrag(arg) {
      /* Controllo di non aver draggato un elemento a
       * caso su un'intestazione: sulle intestazioni
       * si possono rilasciare solo gli span. */
      let interupt_for_exception = 0;

      switch (arg.detail.caveat) {
        case "intestazione":
          if (
            this.oggetto_sel.tipo_oggetto != "I" &&
            this.oggetto_sel.text != "span"
          ) {
            this.drag_state = "off";
            this.$refs.SnackbarQV.print(
              "orange",
              "In una riga di intestazione si possono rilasciare solo elementi Span."
            );
            interupt_for_exception = 1;
          }
          break;
        default:
          break;
      }

      // Se ho rilevato un'eccezione non proseguo nella logica.
      if (interupt_for_exception === 1) {
        return;
      }

      /* Rimuovo l'elemento selezionato da altre
       * posizioni in cui magari era già presente.
       * Non lo faccio per gli elementi con
       * tipo_oggetto == I perché questi effettivamente
       * possono essere ripetuti: per esempio possono
       * essere v-text-field con differenti v-model. */
      if (this.oggetto_sel.tipo_oggetto != "I") {
        this.deleteObject(
          this.colonne,
          "id_header",
          this.oggetto_sel.id_header
        );
      }

      /* Se l'elemento ha tipo_oggetto == I gli metto un
       * id_layout_dettaglio_tmp nuovo perché altrimenti si
       * prenderebbe il riferimento dell'elemento draggato
       * dal menu laterale; dato che gli elementi con
       * tipo_oggetto == I possono ricorrere più volte
       * l'identificativo risulterebbe ripetuto e vogliamo
       * evitarlo. */
      if (this.oggetto_sel.tipo_oggetto == "I") {
        this.oggetto_sel.id_layout_dettaglio_tmp = -moment().valueOf();
      }

      // Associo l'elemento all'ultima posizione in cui ho draggato */
      this.associaElemento(this.colonne, arg.detail.id_layout_struttura_tmp);
    },
    handleMouseUp() {
      this.drag_state = "off";
    },
    handleSalvateAssociazioni() {
      this.dialog_associazioni = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Associazioni salvate con successo."
      );
    },
    invalidateCurrentLayout(arg) {
      // DEPRECATO
      for (let r = 0; r < arg.length; r++) {
        arg[r].validita = 0;

        for (let c = 0; c < arg[r].colonne.length; c++) {
          arg[r].colonne[c].validita = 0;
          this.invalidateCurrentLayout(arg[r].colonne[c].righe);
        }
      }
    },
    async loadDataFromClipboard() {
      // DEPRECATO

      /* Se il titolo è nullo, vuol dire che non ho caricato
       * un layout e non sto generando un nuovo layout, sono
       * solo entrato nella vista e ho cominciato a cliccare a caso.
       * Se è così dico all'utente di creare un layout prima di
       * editare la dashboard. */
      if (this.titolo_layout_sel === null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Creare un nuovo layout o caricarlo prima di modificare la dashboard."
        );
        return;
      }

      /* Mi reparo le variabili che definiscono come è
       * andato il processo di recupero dati dagli appunti
       * e l'array in cui inserirò i dati eventualmente recuperati. */
      let execution = 1;
      let arr_tmp = new Array();

      try {
        // Provo a recuperare i dati dagli appunti.
        arr_tmp = JSON.parse(await navigator.clipboard.readText());
      } catch (e) {
        // Se intercetto un errore registro che qualcosa è andato storto.
        execution = 0;
        console.error(e);
        this.$refs.SnackbarQV.print(
          "error",
          "I dati negli appunti non sono conformi al formato di un documento di layout."
        );
      }

      /* Se il recupero è andato a buon fine e
       * ci sono dati nell'array, inserisco i
       *  dati nella dashboard. */
      if (execution === 1 && arr_tmp.length > 0) {
        // Aggiusto id_layout e id_layout_dettaglio degli oggetti importati.
        this.setIdsAfterImport(arr_tmp);

        // Rendo non valide tutte le strutture attuali del layout.
        await this.invalidateCurrentLayout(this.colonne[0].righe);

        // Monto le nuove strutture sul vecchio layout.
        arr_tmp[0].righe.forEach((r) => {
          this.colonne[0].righe.push(JSON.stringify(r));
        });
        this.key_rows = this.key_rows === 0 ? 1 : 0;
      }
    },
    openDialogPostquery() {
      this.input_args.from_esterno = true;
      this.dialog_query_post = true;
      this.key_windowframe_postquery =
        this.key_windowframe_postquery === 1 ? 0 : 1;
    },
    openDialogPrequery() {
      this.input_args.from_esterno = true;
      this.dialog_query_pre = true;
      this.key_windowframe_prequery =
        this.key_windowframe_prequery === 1 ? 0 : 1;
    },
    openDialogQueryPrincipale() {
      this.input_args.from_esterno = true;
      this.input_args.custom_keyword =
        this.modulo_layout_sel == "AVANZAMENTO" ? "@" : null;
      this.dialog_query_principale = true;
      this.key_windowframe_principale =
        this.key_windowframe_principale === 1 ? 0 : 1;
    },
    resetSelection(arg) {
      for (let c = 0; c < arg.length; c++) {
        arg[c] = new ColumnObject(arg[c]);

        for (let r = 0; r < arg[c].righe.length; r++) {
          arg[c].righe[r] = new RowObject(arg[c].righe[r]);
          this.resetSelection(arg[c].righe[r].colonne);
        }
      }
    },
    retreiveOperazioni(arg_cosa, arg_dove) {
      // Per ogni colonna...
      for (let c = 0; c < arg_dove.length; c++) {
        // ... Ciclo sugli oggetti della colonna.
        for (let obj = 0; obj < arg_dove[c].oggetto.length; obj++) {
          /* Se ci sono operazioni che corrispondono a questo
           * oggetto, le inserisco nell'array-collettore. */
          this.operazioni
            .filter(
              (op) =>
                arg_dove[c].oggetto[obj].id_header == op.id_header &&
                arg_dove[c].oggetto[obj].validita == 1
            )
            .forEach((opz) => {
              arg_cosa.push({
                cod_operazione: opz.cod_operazione,
                des_operazione: opz.des_operazione,
              });
            });
        }

        /* Quando ho finito di esaminare gli oggetti di questa colonna,
         * entro nelle righe che la colonna contine e applico ricorsivamente
         * questa funzione ache sulle colonne che sono lì dentro. */
        for (let r = 0; r < arg_dove[c].righe.length; r++) {
          this.retreiveOperazioni(arg_cosa, arg_dove[c].righe[r].colonne);
        }
      }
    },
    ricercaColonna(arg_dove, arg_cosa) {
      for (let c = 0; c < arg_dove.length; c++) {
        if (arg_dove[c].id_layout_struttura_tmp === arg_cosa) {
          this.colonna_sel = arg_dove[c];
          this.colonna_sel.selezionata = 1;
          this.modalita_selezione = "colonna";
          this.key_rows = this.key_rows === 0 ? 1 : 0;
          this.$forceUpdate();
          return;
        } else {
          for (let r = 0; r < arg_dove[c].righe.length; r++) {
            this.ricercaColonna(arg_dove[c].righe[r].colonne, arg_cosa);
          }
        }
      }
    },
    ricercaRiga(arg_dove, arg_cosa) {
      for (let c = 0; c < arg_dove.length; c++) {
        for (let r = 0; r < arg_dove[c].righe.length; r++) {
          if (arg_dove[c].righe[r].id_layout_struttura_tmp === arg_cosa) {
            this.riga_sel = arg_dove[c].righe[r];
            this.riga_sel.selezionata = 1;
            this.modalita_selezione = "riga";
            this.key_rows = this.key_rows === 0 ? 1 : 0;
            return;
          } else {
            this.ricercaRiga(arg_dove[c].righe[r].colonne, arg_cosa);
          }
        }
      }
    },
    salvaLayout() {
      /* Se il titolo è nullo, vuol dire che non ho caricato
       * un layout e non sto generando un nuovo layout, sono
       * solo entrato nella vista e ho cominciato a cliccare a caso.
       * Se è così dico all'utente di creare un layout prima di
       * editare la dashboard. */
      if (this.titolo_layout_sel === null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Creare un nuovo layout o caricarlo prima di salvare la dashboard."
        );
        return;
      }

      // Mi faccio un array di supporto da modificare.
      const arr_tmp = [new ColumnObject(this.colonne[0])];

      // Cancello dall'array di supporto gli elementi nuovi e non validi.
      // this.deleteNullRows(arr_tmp);
      // this.deleteNullColumns(arr_tmp);
      // this.deleteNullDetails(arr_tmp);

      this.checkIdLayout(arr_tmp);

      // Se i controlli sono stati superati, procedo al salvataggio.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setlayoutstruttura",
          token: localStorage.user_token,
          intestazione: [
            {
              id_layout: this.colonne[0].id_layout,
              modulo: this.modulo_layout_sel,
              query: this.query_layout_sel,
            },
          ],
          layout: arr_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // ... Carico i dati aggiornati.
            this.getLayoutStruttura({
              titolo: this.titolo_layout_sel,
              query: this.query_layout_sel,
              id_layout: this.colonne[0].id_layout,
              id_layout_tmp: this.colonne[0].id_layout_tmp,
            });

            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    salvaModificaBottone() {
      // Aggiorno il layout.
      this.overlay_carica_layout = true;
      this.updateButton(this.colonne);
      this.overlay_carica_layout = false;

      /* Compongo una request e aggiorno i dati
       * sul DB per i bottoni resettati. */
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: [new Bottone(this.bottone_sel)],
          token: localStorage.user_token,
          no_update_utente: 1,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_modifica_bottone = false;
            this.getLayoutDettaglio();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    salvaModificaColonna(arg_dove) {
      for (let c = 0; c < arg_dove.length; c++) {
        if (
          arg_dove[c].id_layout_struttura_tmp ===
          this.colonna_tmp.id_layout_struttura_tmp
        ) {
          this.$set(arg_dove, c, new ColumnObject(this.colonna_tmp));

          /* Dopo aver aplicato le modifiche alla colonna, applico
           * le modifiche ai suoi oggetti (solo sul primo livello). */
          for (let o = 0; o < arg_dove[c].oggetto.length; o++) {
            for (let field in this.colonna_tmp) {
              if (
                field === "font_color_dato" ||
                field === "font_color_titolo" ||
                field === "font_size_icona" ||
                field === "font_size_dato" ||
                field === "font_size_titolo" ||
                field === "font_weight_dato" ||
                field === "font_weight_titolo"
              ) {
                this.$set(
                  arg_dove[c].oggetto[o],
                  field,
                  this.colonna_tmp[field]
                );
              }
            }
          }

          this.colonna_sel = arg_dove[c];
          this.key_rows = this.key_rows === 0 ? 1 : 0;
          this.dialog_modifica_colonna = false;
          return;
        } else {
          for (let r = 0; r < arg_dove[c].righe.length; r++) {
            this.salvaModificaColonna(arg_dove[c].righe[r].colonne);
          }
        }
      }
    },
    salvaModificaDato() {
      // Aggiorno il layout.

      this.updateButton(this.colonne);

      /* Compongo una request e aggiorno i dati
       * sul DB per i bottoni resettati. */
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: [new Bottone(this.bottone_sel)],
          token: localStorage.user_token,
          no_update_utente: 1,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.dialog_modifica_dato = false;

            this.overlay = true;
            await this.getLayoutDettaglio();
            this.overlay = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    async salvaModificaNotifica() {
      /* Se sto salvando una notifica nuova, salvo
       * e aggiorno l'array delle notifiche. */
      if (this.oggetto_sel.id_header == null) {
        await this.saveNewNotification();
        this.dialog_modifica_notifica = false;
      } else {
        /* Se sto salvando una notifica già esistente,
         * salvo le modifiche, aggiorno l'array delle
         * notifiche e aggiorno anche i dati locali
         * del grafico. */
        await this.updateNotificationAPI();
        this.updateNotificationLocal(this.colonne);
        this.dialog_modifica_notifica = false;
      }
    },
    salvaModificaOggetto(arg_dove) {
      for (let c = 0; c < arg_dove.length; c++) {
        if (arg_dove[c].oggetto.length > 0) {
          for (let o = 0; o < arg_dove[c].oggetto.length; o++) {
            if (
              arg_dove[c].oggetto[o].id_layout_dettaglio_tmp ===
              this.oggetto_sel.id_layout_dettaglio_tmp
            ) {
              this.$set(
                arg_dove[c].oggetto,
                o,
                new DetailObject(this.oggetto_sel)
              );
              this.key_rows = this.key_rows === 0 ? 1 : 0;
              this.dialog_modifica_oggetto = false;
            }
          }
        } else {
          for (let r = 0; r < arg_dove[c].righe.length; r++) {
            this.salvaModificaOggetto(arg_dove[c].righe[r].colonne);
          }
        }
      }
    },
    salvaModificaRiga(arg_dove) {
      // Cerco fra le righe della mia colonna la riga che ho appena modificato.
      for (let c = 0; c < arg_dove.length; c++) {
        for (let r = 0; r < arg_dove[c].righe.length; r++) {
          // Se trovo la riga appena modificata, applico le modifiche.
          if (
            arg_dove[c].righe[r].id_layout_struttura_tmp ===
            this.riga_tmp.id_layout_struttura_tmp
          ) {
            this.$set(arg_dove[c].righe, r, new RowObject(this.riga_tmp));

            /* Dopo aver aplicato le modifiche alla riga, applico
             * le modifiche alle sue colonne e ai loro oggetti
             * (solo sul primo livello). */
            for (let c2 = 0; c2 < arg_dove[c].righe[r].colonne.length; c2++) {
              for (let field in this.riga_tmp) {
                if (
                  field === "colore_colonna" ||
                  field === "colore_riga" ||
                  field === "colore_sfondo" ||
                  field === "dimensione" ||
                  field === "font_color_dato" ||
                  field === "font_color_titolo" ||
                  field === "font_size_icona" ||
                  field === "font_size_dato" ||
                  field === "font_size_titolo" ||
                  field === "font_weight_dato" ||
                  field === "font_weight_titolo"
                ) {
                  this.$set(
                    arg_dove[c].righe[r].colonne[c2],
                    field,
                    this.riga_tmp[field]
                  );
                }
              }

              for (
                let o = 0;
                o < arg_dove[c].righe[r].colonne[c2].oggetto.length;
                o++
              ) {
                for (let field in this.riga_tmp) {
                  if (
                    field === "colore_icona" ||
                    field === "font_color_dato" ||
                    field === "font_color_titolo" ||
                    field === "font_size_icona" ||
                    field === "font_size_dato" ||
                    field === "font_size_titolo" ||
                    field === "font_weight_dato" ||
                    field === "font_weight_titolo"
                  ) {
                    this.$set(
                      arg_dove[c].righe[r].colonne[c2].oggetto[o],
                      field,
                      this.riga_tmp[field]
                    );
                  }
                }
              }
            }

            this.riga_sel = arg_dove[c].righe[r];
            this.key_rows = this.key_rows === 0 ? 1 : 0;
            this.dialog_modifica_riga = false;
            return;
          } else {
            this.salvaModificaRiga(arg_dove[c].righe[r].colonne);
          }
        }
      }
    },
    salvaNuovoLayout() {
      const id_layout_tmp = -moment().valueOf();
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setlayout",
          token: localStorage.user_token,
          layout: [
            {
              id_layout: -1,
              id_layout_tmp: id_layout_tmp,
              titolo: this.titolo_layout_tmp,
              modulo: this.modulo_layout_tmp,
              validita: 1,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // Carico il dettaglio del layout appena salvato.
            this.getLayoutStruttura({
              titolo: this.titolo_layout_tmp,
              modulo: this.modulo_layout_tmp,
              id_layout: res.data.result,
              id_layout_tmp: id_layout_tmp,
            });

            /* Chiudo Registro il modulo selezionato
             * e chiudo la finestra di dialogo di creazione. */
            this.modulo_layout_sel = this.modulo_layout_tmp;
            this.dialog_nuovo_layout = false;

            // Resetto il titolo e il modulo temporanei.
            this.titolo_layout_tmp = "";
            this.modulo_layout_tmp = "";
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    saveNewNotification() {
      // Salvo la nuova notifica.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: [
            {
              id_header: -1,
              colore_sfondo: this.oggetto_sel.colore_sfondo,
              colore_icona: this.oggetto_sel.font_color_dato,
              modulo: "AVANZAMENTO",
              // modulo: "ALLEGATO",
              ordine: this.items_notifiche.length + 1,
              text: this.oggetto_sel.text,
              tipo_oggetto: this.oggetto_sel.tipo_oggetto,
              tooltip: this.oggetto_sel.tooltip,
            },
          ],
          token: localStorage.user_token,
          no_update_utente: 1,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            // Prendo le notifiche aggiornate.
            await this.getUpdatedNotifications();
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
          return false;
        });
    },
    selectColumn(arg) {
      // Deseleziono la colonna selezionata.
      this.riga_sel.selezionata = 0;

      // Resetto la riga selezionata.
      this.riga_sel = new RowObject();

      // Resetto la modalità di selezione.
      this.modalita_selezione = "colonna";

      /* Uso un puntatore per prendere il
       * riferimento alla colonna selezionata. */
      this.colonna_sel = arg;
      this.colonna_sel.selezionata = 1;
      this.key_rows = this.key_rows === 0 ? 1 : 0;
    },
    async selectLayout(arg) {
      this.modulo_layout_sel = arg.modulo;
      this.overlay_carica_layout = true;
      this.getLayoutStruttura(arg);
      await this.getLayoutDettaglio();
      this.overlay_carica_layout = false;
    },
    selectRow(arg) {
      // Deseleziono la colonna selezionata.
      this.colonna_sel.selezionata = 0;

      // Resetto la colonna selezionata.
      this.colonna_sel = new ColumnObject();

      // Resetto la modalità di selezione.
      this.modalita_selezione = "riga";

      /* Uso un puntatore per prendere il
       * riferimento alla riga selezionata. */
      this.riga_sel = arg;
      this.riga_sel.selezionata = 1;
      this.key_rows = this.key_rows === 0 ? 1 : 0;
    },
    setIdsAfterImport(arr) {
      // DEPRECATO
      // Pero ogni colonna di questo array...
      for (let c = 0; c < arr.length; c++) {
        // Resetto gli identificativi della colonna.
        arr[c].id_layout = this.colonne[0].id_layout;
        arr[c].id_layout_tmp = this.colonne[0].id_layout_tmp;
        arr[c].id_layout_struttura = -1;

        // Se ci sono righe nella colonna...
        if (arr[c].righe) {
          // ... Per ogni riga...
          for (let r = 0; r < arr[c].righe.length; r++) {
            // Resetto gli identificativi della riga.
            arr[c].righe[r].id_layout = this.colonne[0].id_layout;
            arr[c].righe[r].id_layout_tmp = this.colonne[0].id_layout_tmp;
            arr[c].righe[r].id_layout_struttura = -1;

            /* Se ci sono colonne nella riga, applico
             * questa funzione su di loro ricorsivamente. */
            if (arr[c].righe[r].colonne) {
              this.setIdsAfterImport(arr[c].righe[r].colonne);
            }
          }
        }
      }
    },
    startDragItem(e, arg) {
      if (e.which === 1) {
        this.oggetto_sel = new DetailObject(arg);
        this.oggetto_sel.font_color_dato = arg.colore_icona;
        this.drag_state = "on";
      }
    },
    updateButton(arg) {
      for (let c = 0; c < arg.length; c++) {
        for (let o = 0; o < arg[c].oggetto.length; o++) {
          if (arg[c].oggetto[o].id_header === this.bottone_sel.id_header) {
            arg[c].oggetto[o].colore_icona = this.bottone_sel.colore_icona;
            arg[c].oggetto[o].colore_sfondo = this.bottone_sel.colore_sfondo;
            arg[c].oggetto[o].icona = this.bottone_sel.icona;
            arg[c].oggetto[o].postquery = this.bottone_sel.postquery;
            arg[c].oggetto[o].prequery = this.bottone_sel.prequery;
            arg[c].oggetto[o].testo = this.bottone_sel.testo;
            arg[c].oggetto[o].tooltip = this.bottone_sel.tooltip;
            arg[c].oggetto[o].value = this.bottone_sel.value;
          }
        }

        /* Applico recursivamente questa funzione a tutte
         * le colonne di tutte le righe nella colonna
         * attualemnte iterata. */
        for (let r = 0; r < arg[c].righe.length; r++) {
          this.updateButton(arg[c].righe[r].colonne);
        }
      }
    },
    updateCursorCoordinates(e) {
      this.cursor_x =
        e.clientX -
        document.getElementById("listener_layout").getBoundingClientRect().x;

      this.cursor_y =
        e.clientY -
        document.getElementById("listener_layout").getBoundingClientRect().y;
    },
    updateInfo(arg) {
      for (let c = 0; c < arg.length; c++) {
        for (let o = 0; o < arg[c].oggetto.length; o++) {
          if (arg[c].oggetto[o].id_header === this.info_sel.id_header) {
            arg[c].oggetto[o].filtrabile = this.info_sel.filtrabile;
          }
        }

        /* Applico recursivamente questa funzione a tutte
         * le colonne di tutte le righe nella colonna
         * attualemnte iterata. */
        for (let r = 0; r < arg[c].righe.length; r++) {
          this.updateInfo(arg[c].righe[r].colonne);
        }
      }
    },
    updateNotificationAPI() {
      // Salvo la notifica da aggiornare.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: [
            {
              id_header: this.oggetto_sel.id_header,
              colore_sfondo: this.oggetto_sel.colore_sfondo,
              colore_icona: this.oggetto_sel.font_color_dato,
              modulo: "AVANZAMENTO",
              // modulo: "ALLEGATO",
              ordine: this.items_notifiche.length + 1,
              text: this.oggetto_sel.text,
              tipo_oggetto: this.oggetto_sel.tipo_oggetto,
              tooltip: this.oggetto_sel.testo,
            },
          ],
          token: localStorage.user_token,
          no_update_utente: 1,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            // Prendo le notifiche aggiornate.
            await this.getUpdatedNotifications();
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
          return false;
        });
    },
    updateNotificationLocal(arg) {
      for (let c = 0; c < arg.length; c++) {
        for (let o = 0; o < arg[c].oggetto.length; o++) {
          if (arg[c].oggetto[o].id_header === this.oggetto_sel.id_header) {
            arg[c].oggetto[o] = new DetailObject(this.oggetto_sel);
            this.key_rows = this.key_rows === 0 ? 1 : 0;
          }
        }

        /* Applico recursivamente questa funzione a tutte
         * le colonne di tutte le righe nella colonna
         * attualemnte iterata. */
        for (let r = 0; r < arg[c].righe.length; r++) {
          this.updateNotificationLocal(arg[c].righe[r].colonne);
        }
      }
    },
    visualizzaOperazioni() {
      this.dialog_operazioni = true;
    },
  },
  mounted() {
    // Aggiungo un listener per gli eventi end of drag.
    document
      .getElementById("listener_layout")
      .addEventListener("endOfDrag", this.handleEndOfDrag);

    // Aggiungo un listener per l'evento click sulla colonna.
    document
      .getElementById("listener_layout")
      .addEventListener("clickedColumn", this.handleClickedColumn);

    // Aggiungo un listener per l'evento click sulla riga.
    document
      .getElementById("listener_layout")
      .addEventListener("clickedRow", this.handleClickedRow);

    // Aggiungo un listener per l'evento doppio click sulla colonna.
    document
      .getElementById("listener_layout")
      .addEventListener("contextMenuColumn", this.handleContextMenuColumn);

    // Aggiungo un listener per l'evento doppio click sulla riga.
    document
      .getElementById("listener_layout")
      .addEventListener("contextMenuRow", this.handleContextMenuRow);

    // Aggiungo un listener per l'evento doppio click sulla riga.
    document
      .getElementById("listener_layout")
      .addEventListener("contextMenuObject", this.handleContextMenuObject);

    // Inizializzo il componente e popolo gli array di supporto.
    this.colonne[0].id_layout_tmp = -moment().valueOf();
    this.colonna_sel = this.colonne[0];

    // Colleziono le operazioni.
    this.getOperazioni();

    // Colleziono i layout standard.
    this.getLayoutStandard();
  },
};
</script>